module.exports = __webpack_public_path__ + "img/TopState3Y.45b0886c.png";